import { useState } from 'react';
import { motion } from 'framer-motion';

/**
 * LogoMark — the "ZERO" wordmark for Zeerow Balance.
 *
 * Heavy, filled slab glyphs stacked ZE / RO (no surrounding circle), matching
 * the brand art. Drawn with thick strokes in `currentColor`, so it inherits
 * ink and auto-adapts to light/dark themes. The "O" lights up lime on hover.
 */
export const LogoMark = ({ size = 40, className = '' }) => {
    const [hover, setHover] = useState(false);
    const glyph = {
        stroke: 'currentColor',
        strokeWidth: 11,
        strokeLinecap: 'square',
        strokeLinejoin: 'round',
        fill: 'none',
    };
    return (
        <motion.span
            aria-label="Zeerow Balance by Himanshu Tanty"
            role="img"
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            className={`inline-flex items-center justify-center shrink-0 ${className}`}
            style={{ width: size, height: size }}
            animate={{ rotate: hover ? -4 : 0, scale: hover ? 1.05 : 1 }}
            transition={{ type: 'spring', stiffness: 280, damping: 18 }}
        >
            <svg
                viewBox="0 0 100 100"
                width={size}
                height={size}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
            >
                {/* Z — top-left */}
                <path d="M9 13 H45 L9 44 H45" {...glyph} />

                {/* E — top-right, three bars */}
                <path d="M55 13 H92" {...glyph} />
                <path d="M55 28.5 H92" {...glyph} />
                <path d="M55 44 H92" {...glyph} />

                {/* R — bottom-left */}
                <path d="M14 56 V91" {...glyph} />
                <path d="M14 56 H31 C43 56 43 74 31 74 H14" {...glyph} />
                <path d="M23 74 L42 91" {...glyph} />

                {/* O — bottom-right ring, lights up on hover */}
                <motion.circle
                    cx="73"
                    cy="73"
                    r="17.5"
                    fill="none"
                    strokeWidth="11"
                    animate={{ stroke: hover ? 'var(--accent, #D8FE5B)' : 'currentColor' }}
                    transition={{ duration: 0.3 }}
                />
            </svg>
        </motion.span>
    );
};

export default LogoMark;
